import { jsx } from 'react/jsx-runtime';
import { S as StoryblokComponent } from './StoryblokComponent-server-DCJyvOF5.mjs';
import { C as ClientStoryblokStory } from './ClientStoryblokStory-shared-DKhtalt5.mjs';

const StoryblokStory = ({ story, preview, ...rest })=>{
    if (preview) {
        return /*#__PURE__*/ jsx(ClientStoryblokStory, {
            ...rest,
            preview: true,
            story: story
        });
    }
    return /*#__PURE__*/ jsx(StoryblokComponent, {
        ...rest,
        preview: preview,
        blok: story == null ? void 0 : story.content
    });
};

export { StoryblokStory as S };
